// extracted by mini-css-extract-plugin
module.exports = {"sticker":"style__sticker__6-ILa"};